import React from 'react';
import { Linkedin, Heart } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="py-8 bg-background border-t border-border">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo & Copyright */}
          <div className="flex flex-col items-center md:items-start gap-2">
            <span className="font-heading font-bold text-lg text-foreground">
              NO<span className="text-primary">.</span>
            </span>
            <p className="text-sm text-muted-foreground">
              © {currentYear} Narek Onanyan. All rights reserved.
            </p>
          </div>

          {/* Social Link */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/in/narekonanyan"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-lg bg-secondary flex items-center justify-center text-muted-foreground hover:text-primary hover:bg-primary-soft transition-colors"
              aria-label="LinkedIn Profile"
            >
              <Linkedin size={20} />
            </a>
          </div>
        </div>

        {/* Bottom text */}
        <div className="mt-6 pt-6 border-t border-border/50 text-center">
          <p className="text-xs text-muted-foreground flex items-center justify-center gap-1">
            Built with <Heart size={12} className="text-primary" /> for a modern web experience
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
